import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { CommonFunctions } from '../../../../utils/common-functions';
import { NgxPopupComponent } from '../../ngx-popups/ngx-popups/components/popup.component';
import { PERIOD_TYPES, DATE_FORMAT, UPLOAD_DOC_TYPES } from '../../../../utils/constants';
import { NgxPopupService } from '../../ngx-popups/ngx-popups/ngx-popups';
import { ShareLinkComponent } from './share-link/share-link.component';
import { SignedUrlService } from '../../../../services/signed-url.service';
import { BorrowerService } from '../../../../services/borrower.service';
import { UserService } from '../../../../services/user.service';
import { AutoUnsubscribe } from '../../../../decorators/auto-unsubscribe';
import { Subscription } from 'rxjs';
import { BankSettingsService } from '../../../../services/bank-settings.service';

@Component({
    selector: 'app-request-statements',
    templateUrl: './request-statements.component.html',
    styleUrls: ['./request-statements.component.scss'],
    standalone: false
})

@AutoUnsubscribe('subsArr$')
export class RequestStatementsComponent implements OnInit {
  @Input() popup: NgxPopupComponent;
  periodTypes = PERIOD_TYPES;
  uploadDocumentTypes = UPLOAD_DOC_TYPES;
  selectedPeriodType: string;
  selectedStatementDate: string;
  selectedStatementDateFrom: string;
  selectedStatementDateTo: string;
  selectedTypes = [];
  portalLink: string;
  otherDocs = [];
  oneMonth: boolean;
  multiMonth: boolean;
  subsArr$: Subscription[] = [];
  hostname: string;

  constructor(private _popupService: NgxPopupService,
              private _userService: UserService,
              private _signedUrlService: SignedUrlService,
              private _borrowerService: BorrowerService,
              private _bankSettingsService: BankSettingsService) {
  }

  ngOnInit(): void {
    this._setInitialValues();
    this.oneMonth = true;
    this.otherDocs = [
      {
        'checked': false,
        'text': null
      }
    ];
  }

  togglePeriodsRequested(multiMonth?: boolean) {
    if (multiMonth) {
      this.oneMonth = false;
      this.multiMonth = true;
    } else {
      this.oneMonth = true;
      this.multiMonth = false;
    }
  }

  generateLink() {
    const company = this._borrowerService.company;
    this.subsArr$.push(this._userService.getCurrentUser().subscribe(user => {
        const state = {
          'selectedPeriodType': this.selectedPeriodType,
          'selectedStatementDate': this.selectedStatementDate,
          'selectedStatementDateFrom': this.selectedStatementDateFrom,
          'selectedStatementDateTo': this.selectedStatementDateTo,
          'notify': user.email,
          'multiMonth': this.multiMonth,
          'selectedTypes': this.selectedTypes
        }

        if (company) {
          const bankId = this._userService.getBankId();
          this.subsArr$.push(this._bankSettingsService.getCName().subscribe(hostname => {
            if (hostname) {
              if (hostname.startsWith('http')) {
                this.hostname = hostname;
              } else {
                this.hostname = 'https://' + hostname;
              }
            } else {
              this.hostname = window.location.origin;
            }

            this.subsArr$.push(this._signedUrlService.createPortalBorrowerUploadUrl(company.id, state).subscribe(data => {
              this.portalLink = this.hostname + '/portal/' + bankId + '/' + data.key;
              this.portalLinkRetrieved();
            }));
          }));
        }
    }));
  }

  portalLinkRetrieved() {
    this.popup.close();

    this._popupService.open({
      componentType: ShareLinkComponent,
      cssClass: 'modal-add-user',
      inputs: {
        selectedPeriodType: this.selectedPeriodType,
        selectedStatementDate: this.selectedStatementDate,
        selectedStatementDateFrom: this.selectedStatementDateFrom,
        selectedStatementDateTo: this.selectedStatementDateTo,
        multiMonth: this.multiMonth,
        selectedTypes: this.selectedTypes,
        portalLink: this.portalLink
      }
    }).then((popup: NgxPopupComponent) => {
      popup.addEventListener('close', (data: CustomEvent) => {
      }, {once: true});
    });
  }

  changePeriodType(event): void {
    this.selectedPeriodType = event.target.value;
  }

  updateStatementDate(event, multiPeriod?: boolean, from?: boolean): void {
    if (multiPeriod && from) {
      this.selectedStatementDateFrom = event.dateObject.formatted;
    } else if (multiPeriod) {
      this.selectedStatementDateTo = event.dateObject.formatted;
    } else {
      this.selectedStatementDate = event.dateObject.formatted;
    }
  }

  addDocToArray(docName) {
    this.selectedTypes.push(docName);
  }

  removeDocFromArray(docName) {
    this.selectedTypes.splice(this.selectedTypes.indexOf(docName), 1 );
  }

  arrayContainsDoc(docName): boolean {
    if (this.selectedTypes.includes(docName)) {
      return true;
    } else {
      return false;
    }
  }

  addInput(docTypeValue, checked) {
    if (!checked) {
      checked = true;
    } else {
      checked = false;
    }

    if (checked) {
      this.otherDocs.push({
        'checked': false,
        'text': null
      });
    } else {
      this.otherDocs.pop();
    }

    if (docTypeValue) {
      this.onDocTypeClick(docTypeValue, true, checked);
    }
  }

  onDocTypeClick(docTypeValue, other?: boolean, checked?: boolean): void {
    if (!docTypeValue) {
      return
    }

    if (other) {
      if (checked) {
        this.addDocToArray(docTypeValue);
      } else if (this.arrayContainsDoc(docTypeValue)) {
        this.removeDocFromArray(docTypeValue);
      }
    } else {
      if (this.arrayContainsDoc(docTypeValue)) {
        this.removeDocFromArray(docTypeValue);
      } else {
        this.addDocToArray(docTypeValue);
      }
    }

  }

  private _setInitialValues(): void {
    this.selectedPeriodType = this.periodTypes[0].key;
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '/' + today.getDate();
    this.selectedStatementDate = this.selectedStatementDateTo = this.selectedStatementDateFrom = moment(date).format(DATE_FORMAT);
  }
}
